module.exports = __webpack_public_path__ + "img/base_patrimoine_geologie.ad712490.svg";